import { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL || ''

export default function Encuesta() {
  const { token } = useParams()
  const [info, setInfo] = useState(null)
  const [puntuacion, setPuntuacion] = useState(0)
  const [comentario, setComentario] = useState('')
  const [enviado, setEnviado] = useState(false)
  const [error, setError] = useState('')
  const [enviando, setEnviando] = useState(false)

  useEffect(() => {
    axios.get(`${API}/api/encuestas/${token}`)
      .then(res => {
        if (res.data.ya_respondida) setEnviado(true)
        else setInfo(res.data)
      })
      .catch(() => setError('Enlace no válido o encuesta expirada.'))
  }, [token])

  const enviar = async () => {
    if (!puntuacion) { setError('Selecciona una puntuación.'); return }
    setEnviando(true); setError('')
    try {
      await axios.post(`${API}/api/encuestas/${token}`, { puntuacion, comentario })
      setEnviado(true)
    } catch (err) {
      setError(err.response?.data?.error || 'Error al enviar la valoración.')
    } finally {
      setEnviando(false)
    }
  }

  if (error && !info) return (
    <div className="form-page">
      <div className="form-card" style={{ maxWidth: 480, textAlign: 'center' }}>
        <p style={{ color: '#e74c3c' }}>{error}</p>
        <Link to="/" style={{ color: 'var(--gold)', marginTop: '1rem', display: 'block' }}>Volver al inicio</Link>
      </div>
    </div>
  )

  if (enviado) return (
    <div className="form-page">
      <div className="form-card" style={{ maxWidth: 480, textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>★</div>
        <p className="page-label">Gracias</p>
        <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.8rem', fontWeight: 300 }}>Valoración recibida</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginTop: '1rem' }}>
          Tu opinión nos ayuda a mejorar. Esperamos verte pronto.
        </p>
        <Link to="/" style={{ color: 'var(--gold)', display: 'block', marginTop: '2rem', fontSize: '0.75rem', letterSpacing: '0.15em', textTransform: 'uppercase' }}>
          Volver al inicio
        </Link>
      </div>
    </div>
  )

  if (!info) return <div className="loading">Cargando...</div>

  return (
    <div className="form-page">
      <div className="form-card" style={{ maxWidth: 520 }}>
        <p className="page-label">El Rincón de la Escandella</p>
        <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.8rem', fontWeight: 300 }}>¿Qué tal tu visita?</h1>
        <p className="subtitle">Hola {info.nombre}, cuéntanos tu experiencia del {new Date(info.fecha + 'T00:00:00').toLocaleDateString('es-ES', { day: 'numeric', month: 'long' })}.</p>

        {error && <div className="error-msg">{error}</div>}

        {/* Estrellas */}
        <div className="form-group" style={{ marginTop: '1.5rem' }}>
          <label>Puntuación</label>
          <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.75rem' }}>
            {[1, 2, 3, 4, 5].map(n => (
              <button
                key={n}
                type="button"
                onClick={() => setPuntuacion(n)}
                style={{
                  fontSize: '2rem',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: n <= puntuacion ? 'var(--gold)' : 'var(--border)',
                  transition: 'color 0.2s',
                  padding: '0.25rem',
                }}
              >
                ★
              </button>
            ))}
          </div>
          {puntuacion > 0 && (
            <p style={{ fontSize: '0.7rem', color: 'var(--text-muted)', marginTop: '0.5rem' }}>
              {['', 'Muy mejorable', 'Mejorable', 'Bien', 'Muy bien', 'Excelente'][puntuacion]}
            </p>
          )}
        </div>

        {/* Comentario */}
        <div className="form-group">
          <label>Comentario (opcional)</label>
          <textarea
            value={comentario}
            onChange={e => setComentario(e.target.value)}
            placeholder="Cuéntanos qué te gustó o qué podemos mejorar..."
            style={{ height: '100px' }}
            maxLength={1000}
          />
        </div>

        <button className="btn-primary" onClick={enviar} disabled={enviando || !puntuacion}>
          {enviando ? 'Enviando...' : 'Enviar valoración'}
        </button>
      </div>
    </div>
  )
}
